import { render, staticRenderFns } from "./EditPartnerModal.vue?vue&type=template&id=32a7d410&lang=pug&"
import script from "./EditPartnerModal.vue?vue&type=script&lang=js&"
export * from "./EditPartnerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports